import React from "react";
import { useSelector } from "react-redux";

import { MODAL_TYPES } from "utils/constants";
import AddCreativesToConcept from "widgets/modals/creatives/open/AddCreativesToConcept";
import SubmitCreatives from "widgets/modals/creatives/SubmitCreatives";
import RenameCreatives from "widgets/modals/creatives/RenameCreatives";
import RenameConcepts from "widgets/modals/creatives/RenameConcepts";
import AddCreativesToImposiumProject from "widgets/modals/imposium/AddCreativesToImposiumProjectModal";
import CreateImposiumProject from "widgets/modals/imposium/CreateImposiumProjectModal";
import DuplicateImposiumProjectModal from "widgets/modals/imposium/DuplicateImposiumProjectModal";
import ImposiumMultiCreative from "widgets/modals/imposium/ImposiumMultiCreativeModal";
import DuplicateCreatives from "widgets/modals/creatives/DuplicateCreatives";
import DuplicateConcepts from "widgets/modals/creatives/DuplicateConcepts";
import ApproveCreatives from "widgets/modals/creatives/ApproveCreatives";
import ErrorImportSocialCreativesModal from "widgets/modals/creatives/bulk/ErrorImportSocialCreativesModal";
import RecallCreatives from 'widgets/modals/creatives/RecallCreatives';
import ViewRejectionReason from 'widgets/modals/creatives/ViewRejectionReason';
import RejectCreatives from "widgets/modals/creatives/RejectCreatives";
import ViewEncodes from "widgets/modals/creatives/ViewEncodes";
import PreviewLinkedCreatives from "widgets/modals/PreviewLinkedCreatives";
import AssetPreviewBlade from "widgets/modals/AssetPreviewBlade";
import ConfirmBulkExport from "widgets/modals/creatives/ConfirmBulkExport";
import DTreeModal from "widgets/modals/dtree/DTreeModal";
import ImportVersionsErrorModal from "widgets/modals/versions/ImportVersionsErrorsModal";
import ImposiumCompositionsModal from "widgets/modals/imposium/CompositionsModal";
import SwitchCompositionModal from "widgets/modals/imposium/SwitchCompositionModal";
import RemoveCreativesFromConcept from "widgets/modals/creatives/RemoveCreativesFromConcept";
import ImportDecisionSheetErrorModal from "./versions/ImportDecisionSheetErrorModal";
import ShareCreativePreviews from "widgets/modals/creatives/preview/sharing/ShareCreativePreviews";
import AddCreativeTagsToConcept from "./creatives/AddCreativeTagsToConcept";
import AddAdStudioCreativeToConcept from "./creatives/AddAdStudioCreativeToConcept";
import AfterEffectsUploadErrors from "widgets/modals/assets/AfterEffectsUploadErrors";
import DeleteCreativesErrors from "widgets/modals/creatives/DeleteCreativesErrors";
import ImportTaxonomyModal from "./creatives/bulk/ImportTaxonomyModal";
import EditPartnerVast from "widgets/modals/creatives/vast/EditPartnerVast";
import DuplicateQrCodeDesignModal from "./qrcodes/DuplicateQrCodeDesignModal";
import AssignContentFeed from "widgets/modals/creatives/AssignContentFeed";
import AssignExistingContentFeed from "widgets/modals/creatives/AssignExistingContentFeed";
import AssignNewContentFeed from "widgets/modals/creatives/AssignNewContentFeed";
import ContentFeedDecisioningModal from "./dtree/ContentFeedDecisioningModal";

const MODAL_MAP = {
	[MODAL_TYPES.SUBMIT_CREATIVES]:SubmitCreatives,
	[MODAL_TYPES.ADD_CREATIVES_TO_CONCEPT]:AddCreativesToConcept,
	[MODAL_TYPES.RENAME_CREATIVES]:RenameCreatives,
	[MODAL_TYPES.RENAME_CONCEPT]:RenameConcepts,
	[MODAL_TYPES.APPROVE_CREATIVES]:ApproveCreatives,
	[MODAL_TYPES.ADD_CREATIVES_TO_IMPOSIUM_PROJECT]:AddCreativesToImposiumProject,
	[MODAL_TYPES.CREATE_IMPOSIUM_PROJECT]:CreateImposiumProject,
	[MODAL_TYPES.IMPOSIUM_MULTI_CREATIVE]:ImposiumMultiCreative,
	[MODAL_TYPES.DUPLICATE_CREATIVES]:DuplicateCreatives,
	[MODAL_TYPES.DUPLICATE_IMPOSIUM_PROJECT]:DuplicateImposiumProjectModal,
	[MODAL_TYPES.VIEW_REJECT_REASON]:ViewRejectionReason,
	[MODAL_TYPES.DUPLICATE_CONCEPTS]:DuplicateConcepts,
	[MODAL_TYPES.REJECT_CREATIVES]:RejectCreatives,
	[MODAL_TYPES.socialSocketErrors]:ErrorImportSocialCreativesModal,
	[MODAL_TYPES.IMPORT_TAXONOMY]:ImportTaxonomyModal,
	[MODAL_TYPES.IMPOSIUM_COMPOSITIONS]:ImposiumCompositionsModal,
	[MODAL_TYPES.SWITCH_IMPOSIUM_COMPOSITION]:SwitchCompositionModal,
	[MODAL_TYPES.RECALL_CREATIVES]:RecallCreatives,
	[MODAL_TYPES.VIEW_ENCODES]:ViewEncodes,
	[MODAL_TYPES.PREVIEW_LINKED_CREATTIVES]:PreviewLinkedCreatives,
	[MODAL_TYPES.PREVIEW_ASSET]:AssetPreviewBlade,
	[MODAL_TYPES.CONTENT_FEED_DECISIONING_MODAL]:ContentFeedDecisioningModal,
	[MODAL_TYPES.DECISION_TREE_MODAL]:DTreeModal,
	[MODAL_TYPES.CONFIRM_BULK_EXPORT_VERSIONS]:ConfirmBulkExport,
	[MODAL_TYPES.IMPORT_VERSIONS_ERROR]:ImportVersionsErrorModal,
	[MODAL_TYPES.REMOVE_CREATIVES_FROM_CONCEPT]:RemoveCreativesFromConcept,
	[MODAL_TYPES.IMPORT_DECISION_SHEET_ERROR]: ImportDecisionSheetErrorModal,
	[MODAL_TYPES.ADD_CREATIVE_TAGS_TO_CONCEPT]: AddCreativeTagsToConcept,
	[MODAL_TYPES.ADD_ADSTUDIO_TO_CONCEPT]: AddAdStudioCreativeToConcept,
	[MODAL_TYPES.SHARE_CREATIVE_PREVIEWS]: ShareCreativePreviews,
	[MODAL_TYPES.AE_UPLOAD_ERRORS]: AfterEffectsUploadErrors,
	[MODAL_TYPES.DELETE_CREATIVES_ERRORS]: DeleteCreativesErrors,
	[MODAL_TYPES.EDIT_PARTNER_VAST]:EditPartnerVast,
	[MODAL_TYPES.DUPLICATE_QR_CODE_DESIGN]: DuplicateQrCodeDesignModal,
	[MODAL_TYPES.ASSIGN_CONTENT_FEED]:AssignContentFeed,
	[MODAL_TYPES.ASSIGN_EXISTING_CONTENT_FEED]:AssignExistingContentFeed,
	[MODAL_TYPES.ASSIGN_NEW_CONTENT_FEED]:AssignNewContentFeed,
};

export default function GlobalModals(props){
	let modalInfo = useSelector((state) => {
		return state.modal;
	});

	if(!modalInfo.isOpen){ return null; }

	let Modal = MODAL_MAP[modalInfo.modalType];

	if(Modal){
		return <Modal {...modalInfo.modalOptions} />;
	}

	return null;
}

GlobalModals.displayName = "GlobalModals";
